export default __webpack_public_path__ + "static/media/LHB-USDT.73439364.svg";